export enum Status {
  REQUEST = "REQUEST",
  INACTIVE = "INACTIVE",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}
